import { NumberParam, StringParam } from "use-query-params";

// search params config
export const queryParamsProfesionalConfig = {
  filter: StringParam,
  limit: NumberParam,
};

export const initialProfesionalFilter = {
  limit: 100,
};
